export function $(
) {
   return useNuxtApp().vueApp.config.globalProperties
}